export const unmask = (value) => {
  return value.replace(/\D/g, "");
};

export default unmask;
